import React from 'react';
import { Header, Divider, List } from 'semantic-ui-react';
import { MenuConsumer } from '../../../FoodMenu.context';
import { ModifierSetsBasic } from '../modifiers';
import MenuUtil from '../../../utils/menu';
import ItemVariations from './ItemVariations';

const ItemBasic = ({ id, name, description, variations, onClick, className = '' }) => {
  return (
    <MenuConsumer>
      {({ items, modifierSets, disableModifiers, precision }) => {
        const item = MenuUtil.getItemById(items, id);
        const { modifierSets: itemModifierSetIds } = item;
        const itemModifierSets = MenuUtil.getItemModifierSets(itemModifierSetIds, modifierSets);

        return (
          <List.Item style={{ paddingBottom: '1rem' }} onClick={onClick} className={className}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <Header as="h5">{name}</Header>
              <Divider style={{ flexGrow: 1, margin: '1rem 0.5rem 0 0.5rem' }} />
              <ItemVariations variations={variations} precision={precision} />
            </div>
            <p style={{ marginBottom: '0.25rem' }}>{description}</p>
            {!disableModifiers && <ModifierSetsBasic modifierSets={itemModifierSets} />}
          </List.Item>
        );
      }}
    </MenuConsumer>
  );
};

export default ItemBasic;
